import { Box, Button, Card } from "@material-ui/core";
import { CameraAlt } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import placeholderBanner from "../../assets/Memon_NEWS_mobile.png";
import LoadingAnimation from "../../components/LoadingAnimation";
import MFileUploadButton from "../../components/MFileUploadButton";
import MTextField from "../../components/MTextField";
import { isFieldEmpty } from "../../helpers/appFieldValidation";
import { sendMessageToMobile } from "../../helpers/utils.helper";
import "./addNews.scss";
import { reactQuillModules } from "../../constants/constants.quill";

const AddNewsMobile = (props) => {
  const dispatch = useDispatch();
  const [content, setContent] = useState("");
  const [headline, setHeadline] = useState("");
  const [uploadedImage, setUploadedImage] = useState(placeholderBanner);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [token, setToken] = useState("");
  const [newsId, setNewsId] = useState();
  const [urlParams] = useSearchParams();
  const [loadingApi, setLoadingApi] = useState(false);

  useEffect(() => {
    const newsIdParam = urlParams.get("news_id");
    const tokenParam = urlParams.get("token");
    setNewsId(newsIdParam);
    setToken(tokenParam);
    if (newsIdParam && tokenParam) {
      setLoadingApi(true);
      getNews(newsIdParam, tokenParam);
    }
  }, []);

  const getNews = (id, authToken) => {
    AjaxHelper.getAxiosInstanceToken(authToken)
      .get(`${Endpoint.GET_NEWS}/${id}`)
      .then((response) => {
        setLoadingApi(false);
        if (response.data.status === Status.API_SUCCESS) {
          setUploadedImage(response.data.data.imgUrl ?? placeholderBanner);
          setHeadline(response.data.data.headline);
          setContent(response.data.data.blog);
        } else {
          sendMessageToMobile({
            status: 500,
            message: "Error while fetching News.",
          });
        }
      })
      .catch((err) => {
        setLoadingApi(false);
        sendMessageToMobile({
          status: 500,
          message: "Error while fetching News.",
        });
      });
  };

  const handleSave = () => {
    if (getValidation()) {
      setLoadingApi(true);
      if (isFileUploaded) {
        uploadFile();
      } else {
        if (newsId) {
          updateNews();
        } else {
          addNewsApi();
        }
      }
    }
  };

  const getValidation = () => {
    let isValidated = true;
    if (isFieldEmpty(headline)) {
      sendMessageToMobile({
        status: 400,
        message: "Please provide headline for the news",
      });
      isValidated = false;
    } else if (isFieldEmpty(content)) {
      sendMessageToMobile({
        status: 400,
        message: "Please provide amazing content for the news",
      });
      isValidated = false;
    }

    return isValidated;
  };

  const addNewsApi = (url) => {
    const params = {
      headline: headline,
      description: stripHTMLTags(content),
      blog: content,
      imgUrl: url,
    };

    AjaxHelper.getAxiosInstanceToken(token)
      .post(Endpoint.ADD_NEWS, params)
      .then((response) => {
        setLoadingApi(false);
        sendMessageToMobile(response.data);
      })
      .catch((err) => {
        setLoadingApi(false);
        sendMessageToMobile({ status: 500, message: "Internal server error" });
      });
  };

  const updateNews = (url) => {
    const params = {
      _id: newsId,
      headline: headline,
      description: stripHTMLTags(content),
      blog: content,
      imgUrl: url,
    };
    AjaxHelper.getAxiosInstanceToken(token)
      .post(Endpoint.UPDATE_NEWS, params)
      .then((response) => {
        setLoadingApi(false);
        console.log(params, "logging params");
        sendMessageToMobile(response.data);
      })
      .catch((err) => {
        setLoadingApi(false);
        sendMessageToMobile({
          status: 500,
          message: "Internal server error",
        });
      });
  };

  const uploadFile = () => {
    console.log(selectedFile);
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("key", "news");

    console.log(formData);

    AjaxHelper.getAxiosInstanceMultipartToken(token)
      .post(Endpoint.UPLOAD_FILE, formData)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          if (newsId) {
            updateNews(response.data.data.url);
          } else {
            addNewsApi(response.data.data.url);
          }
        } else {
          setLoadingApi(false);
          sendMessageToMobile({
            status: 500,
            message: "Error while uploading image.",
          });
        }
      })
      .catch((err) => {
        setLoadingApi(false);
        sendMessageToMobile({
          status: 500,
          message: "Error while uploading image.",
        });
      });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    console.log(file);
    if (file) {
      setSelectedFile(file);
      setIsFileUploaded(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const stripHTMLTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
  // Quill.register('modules/emoji', QuillEmoji);

  return (
    <>
      {loadingApi ? <LoadingAnimation /> : null}
      <Box>
        <Card className="addNewsCard">
          <Box className="addNewsContainer">
            <Box
              className="addNewsUploadPhoto"
              style={{
                backgroundImage: `url(${uploadedImage})`,
              }}
            >
              <MFileUploadButton
                icon={CameraAlt}
                onChange={handleImageUpload}
              />
            </Box>

            <Box className="addNewsInput">
              <MTextField
                placeholder="addNewsHeadline"
                value={headline}
                onChange={(e) => setHeadline(e.target.value)}
              />

              <Box className="addNewsReactQuill">
                <ReactQuill
                  className="addNewssReactQuill"
                  value={content}
                  onChange={setContent}
                  modules={{
                    toolbar: reactQuillModules,
                  }}
                  // formats={reactQuillFormats}
                  placeholder="Write something amazing..."
                />
              </Box>

              <Box className="addNewsBtn">
                <Button
                  variant="outlined"
                  onClick={handleSave}
                  style={{ backgroundColor: "#BCBF4E" }}
                >
                  {newsId?._id ? "Update" : "Save"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default AddNewsMobile;
